var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"mykey-banner-img rounded-lg",attrs:{"src":require(`@/assets/images/` + _vm.language + `/banner_generic_top.jpg`),"alt":"banner"}})
}
var staticRenderFns = []

export { render, staticRenderFns }